// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"008e400a","793":"c2d33f51","838":"e55ae843"}[chunkId] + ".js";
};